<aside class="secondary-nav-container d-flex flex-column" [class.visible]="navigationService.showSecondaryNav()"
    [class.collapsed]="!navigationService.isSecondaryExpanded()">

    <!-- Secondary Header / Title -->
    <header class="secondary-nav-header d-flex align-items-center">
        <span class="section-title text-center text-truncate" [title]="navigationService.secondaryNavTitle()">
            {{ 'app.navigation.secondary_nav.title.' + navigationService.secondaryNavTitle() | translate }}
        </span>
        <button mat-icon-button type="button" class="secondary-nav-toggle p-0"
            (click)="navigationService.toggleSecondaryNav()"
            [attr.aria-label]="navigationService.isSecondaryExpanded() ? 'Collapse secondary navigation' : 'Expand secondary navigation'"
            [attr.title]="navigationService.isSecondaryExpanded() ? 'Collapse secondary navigation' : 'Expand secondary navigation'">
            <mat-icon>{{ navigationService.isSecondaryExpanded() ? 'chevron_left' : 'chevron_right' }}</mat-icon>
        </button>
    </header>

    <!-- Scrollable Content Area -->
    <nav class="secondary-nav-content flex-grow-1 pt-4" aria-label="Secondary navigation">
        <ul class="list-unstyled m-0 p-0">

            @for (item of navigationService.secondaryNavItems(); track item.route) {
            <li class="nav-item-container">
                <a [routerLink]="item.route" routerLinkActive="active" #rla="routerLinkActive"
                    [routerLinkActiveOptions]="{ exact: item.exact ?? false }"
                    [matTooltip]="('app.navigation.secondary_nav.item.' + item.label + '.title' | translate) + ' - ' + ('app.navigation.secondary_nav.item.' + item.label + '.description' | translate)"
                    matTooltipPosition="right" [matTooltipShowDelay]=" navigationService.isSecondaryExpanded() ? 500 : 0"
                    class="nav-link d-flex align-items-center position-relative"
                    [attr.aria-current]="rla.isActive ? 'page' : null">

                    <mat-icon class="nav-icon flex-shrink-0" [fontIcon]="item.icon" aria-hidden="true">
                    </mat-icon>

                    <div class="nav-content ms-3 flex-grow-1 overflow-hidden">
                        <div class="nav-title text-truncate">
                            {{ 'app.navigation.secondary_nav.item.' + item.label + '.title' | translate }}
                        </div>
                        <div class="nav-description text-truncate">
                            {{ 'app.navigation.secondary_nav.item.' + item.label + '.description' | translate }}
                        </div>
                    </div>

                    @if (rla.isActive) {
                    <mat-icon class="nav-icon nav-active-icon">arrow_right</mat-icon>
                    }

                </a>
            </li>
            }

        </ul>
    </nav>
</aside>